import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";
import React, { useState, useRef } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";

function QRGenerator(darkMode) {

  const [text, setText] = useState('');
  const qrRef = useRef();

  const handleChange = (e) => {
    setText(e.target.value);
  };

  const downloadQR = () => {
    const canvas = qrRef.current.querySelector('canvas');
    const jpegUrl = canvas.toDataURL('image/jpeg').replace('image/jpeg', 'image/octet-stream');
    const downloadLink = document.createElement('a');
    downloadLink.href = jpegUrl;
    downloadLink.download = 'qr_code.jpeg';
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  return (
    <DashboardLayout>
      <MDBox py={3}>
        <MDBox mt={4.5}>
        <Grid container spacing={3} pt={3} pl={4} pr={3}>
          <div>
              <MDTypography variant="h1" color={darkMode ? "dark" : "white"} >
                QR codes generator
              </MDTypography>
            <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '1.5rem', marginBottom:'40px' }}>
              <div style={{ flex: '1 1 300px' }}>
                <MDTypography fontWeight="regular" color={darkMode ? "dark" : "white"} >
                A QR code (Quick Response) is a type of two-dimensional barcode that can store information such as text, links, phone numbers, and more. You can scan it with your phone's camera to quickly access the stored data. QR codes are useful for sharing information without typing it manually, linking to websites, making payments, displaying contact details, and much more.
                </MDTypography>
              </div>

              <div style={{ textAlign: 'center', flex: '0 0 200px' }}>
                <MDTypography variant="h5" color={darkMode ? "dark" : "white"} >
                  Example of a QR code for this page:
                </MDTypography>
                <img
                  src="https://obsicore-public.s3.us-east-1.amazonaws.com/QRs/obsyra.obsicore.QR.jpeg"
                  alt="Ejemplo de Código QR"
                  style={{ maxWidth: '250px', width: '100%', borderRadius: '25px', padding:'10px'}}
                />
              </div>
            </div>

          <form
            onSubmit={e => {
              e.preventDefault();
              if (!text) alert('Por favor ingresa un texto para generar el QR.');
            }}
            style={{ marginBottom: '1rem' }}
          >
            <MDTypography variant="h5" color={darkMode ? "dark" : "white"} >
              Create your own QR code by entering some text:
            </MDTypography>
            <div style={{padding:'5px'}}>
              <MDBox mb={2}>
                <MDInput type="textField" label="QR string" fullWidth onChange={handleChange} />
              </MDBox>
              {text && (
              <div ref={qrRef} style={{ textAlign: 'center' }}>
                <QRCodeCanvas style={{ borderRadius: '25px'}} value={text} size={256} includeMargin={true} />
                <br />
                <button
                  onClick={downloadQR}
                  style={{
                    marginTop: '1rem',
                    padding: '0.5rem 1rem',
                    fontSize: '1rem',
                    cursor: 'pointer',
                    backgroundColor: '#4caf50',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                  }}
                >
                  Download JPEG
                </button>
              </div>
            )}
            </div>
          </form>
          </div>
          </Grid>
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default QRGenerator;
